import api from "@/api.js";

function generatePlacingsData(race, isTeamEvent, currentEventRounds) {
  let members = [];
  let memberLinks = {};

  console.log(race.lanes);

  race.lanes.forEach(lane => {
    if (!lane.scratched) {
      let memberIndex = 0;
      // Cannot be !memberLinks[lane.participant_id] as index 0 will pass this check doubling the amount of entries
      if (typeof memberLinks[lane.participant_id] == "undefined") {
        memberLinks[lane.participant_id] = members.length;
        memberIndex = members.length;
        members.push({
          rank: lane.placing.includes("D") ? lane.placing : null,
          id: lane.participant_id,
          events_id: lane.events_id,
          name: isTeamEvent
            ? lane.team_name
            : `${lane.firstName} ${lane.lastName}`,
          association_abbr: lane.association_abbr,
          association_id: lane.associations_id,
          points: 0,
          wins: 0,
          worstPos: 0,
          isTeamEvent: isTeamEvent ? 1 : 0
        });
      } else {
        memberIndex = memberLinks[lane.participant_id];
      }
      members[memberIndex].points += lane.points ? parseInt(lane.points) : 0;
      members[memberIndex].wins += parseInt(lane.placing) == 1 ? 1 : 0;
      members[memberIndex].worstPos =
        parseInt(lane.placing) > members[memberIndex].worstPos
          ? parseInt(lane.placing)
          : members[memberIndex].worstPos;
    }
  });

  members.sort((a, b) => {
    let p1 = a.points;
    let p2 = b.points;

    let w1 = a.wins;
    let w2 = b.wins;

    let wp1 = a.worstPos;
    let wp2 = b.worstPos;

    if (p1 < p2) return 1;
    if (p1 > p2) return -1;
    if (w1 < w2) return 1;
    if (w2 > w1) return -1;
    if (wp1 < wp2) return -1;
    if (wp2 > wp1) return 1;
    return 0;
  });

  let currentRank = 1;
  members.forEach((member, index) => {
    if (!member.rank) {
      if (index == 0) {
        currentRank = 1;
        member.rank = 1;
      } else {
        let prevMember = members[index - 1];
        if (
          prevMember.points == member.points &&
          prevMember.wins == member.wins &&
          prevMember.worstPos == member.worstPos
        ) {
          members[index - 1].rank = Number.isInteger(prevMember.rank)
            ? `${prevMember.rank}=`
            : `${prevMember.rank}`;
          member.rank = `${prevMember.rank}`;
          currentRank += 1;
        } else {
          currentRank += 1;
          member.rank =
            currentEventRounds.rounds.length == 1 ? currentRank : index + 1;
        }
      }
    }
  });
  console.log(members);
  return members;
}

async function submitPlacings(currentEventRounds) {
  let races = [];
  let isTeamEvent = JSON.parse(currentEventRounds.playerLabels).length > 1;

  currentEventRounds.rounds.forEach(round => {
    round.races.forEach(race => {
      if (!race.ce_overallFinal) {
        races.push(race);
      }
    });
  });

  let requests = [];
  races.forEach(race => {
    requests.push(
      submitPlacingsAsync({
        placings: generatePlacingsData(
          JSON.parse(JSON.stringify(race)),
          isTeamEvent,
          currentEventRounds
        )
      })
    );
  });

  return await Promise.all(requests);
}
async function submitPlacingsAsync(payload) {
  try {
    let response = await api.post("eventProgress/submit/placings", payload);

    // let response = await this.$store.dispatch(
    //   "eventProgress/submitPlacings",
    //   payload
    // );
    return response;
  } catch (error) {
    return error;
  }
}

export default {
  namespaced: true,
  state: {
    rounds: [],
    roundsLoading: false,
    currentRound: {},
    currentRoundLoading: false,
    currentEventRounds: {},
    currentEventRoundLoading: false
  },
  mutations: {
    setRounds(state, payload) {
      state.rounds = payload;
    },
    setRoundsLoading(state, payload) {
      state.roundsLoading = payload;
    },
    setCurrentRound(state, payload) {
      state.currentRound = payload;
    },
    setCurrentRoundLoading(state, payload) {
      state.currentRoundLoading = payload;
    },
    setCurrentEventRounds(state, payload) {
      state.currentEventRounds = payload;
    },
    setCurrentEventRoundsLoading(state, payload) {
      state.currentEventRoundsLoading = payload;
    }
  },
  actions: {
    async loadRounds({ commit }, id) {
      commit("setRoundsLoading", true);
      let response = await api.get("eventProgress/loadRounds", {
        params: { events_id: id }
      });
      commit("setRounds", response.data);
      commit("setRoundsLoading", false);
    },
    async loadCurrentRound({ commit }, id) {
      commit("setCurrentRoundLoading", true);
      let response = await api.get("eventProgress/loadRoundObject", {
        params: { id: id }
      });
      commit("setCurrentRound", response.data);
      commit("setCurrentRoundLoading", false);
    },
    async loadCurrentEventRoundsObject({ commit }, id) {
      commit("setCurrentEventRoundsLoading", true);
      let response = await api.get(
        "eventProgress/loadCurrentEventRoundsObject",
        {
          params: { id: id }
        }
      );
      commit("setCurrentEventRounds", response.data[0]);
      commit("setCurrentEventRoundsLoading", false);
    },
    async submitRegistration({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/registration", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async drawLanes({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/drawLanes", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async drawLanesFinals({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/drawLanesFinals", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async submitPlacings({ dispatch }, id) {
      let currentEventRounds = await api.get(
        "eventProgress/loadCurrentEventRoundsObject",
        {
          params: { id: id }
        }
      );
      let returnData = await submitPlacings(currentEventRounds.data[0]);
      return returnData;
    },
    async scratchMember({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/scratchMember", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async resetFinalsProgression({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/resetFinalsProgression", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    }
  },
  getters: {
    rounds(state) {
      return state.rounds;
    },
    roundsLoading(state) {
      return state.roundsLoading;
    },
    currentRound(state) {
      return state.currentRound;
    },
    currentRoundLoading(state) {
      return state.currentRoundLoading;
    },
    currentEventRounds(state) {
      return state.currentEventRounds;
    },
    currentEventRoundLoading(state) {
      return state.currentEventRoundLoading;
    }
  }
};
